<script lang="ts">
  import Home from '$lib/home/Home.svelte';
</script>

<Home />
